import type { ReactNode } from "react";
import { Route, Link, Routes, Outlet } from "react-router-dom";
import { toAbsoluteUrl } from "../../helpers/assetHelper";
import { Error404 } from "./Error404";
import { Error500 } from "./Error500";

const ErrorsLayout = ({ children }: { children?: ReactNode }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-subtle px-4 py-10">
      <div className="w-full max-w-[440px] rounded-card bg-white px-8 py-10 text-center shadow-card">
        <Link to="/" className="inline-flex" aria-label="ATS TMS - Acasă">
          <img
            alt="ATS TMS"
            src={toAbsoluteUrl("/logo.svg")}
            className="h-12 w-12 object-contain"
          />
        </Link>
        {children ?? <Outlet />}
        <Link
          to="/"
          className="mt-8 inline-flex min-h-[48px] items-center justify-center rounded-control bg-[#2196f3] px-6 text-base font-semibold text-white transition hover:brightness-95">
          Înapoi la pagina principală
        </Link>
      </div>
    </div>
  );
};

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path="404" element={<Error404 />} />
      <Route path="500" element={<Error500 />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
);

export { ErrorsLayout, ErrorsPage };
